//jQuery.noConflict(); This is probably already called and generates an error

var module = (function($, w) //shortcuts $=jQuery, w=window
{
  const _ = (...myvar) => {console.log(...myvar)};

  if (typeof w.otuApp.triggerAjaxPost != 'function' ) {
	    w.otuApp.triggerAjaxPost = (targetUrl, data, Options) => {
	        _('testing');
	      return $.ajax(
	      {
	        url: targetUrl,
	        method:      'POST',
	        format:      Options.responseType,
	        success:     Options.callback,
	        data:        data
	      });
	    };
	  }


  let APP = {
    init: function(options = {})
    {
      // defaults


      $(".workoutPlayerWrapper").css("opacity",0);

    	// Test if we are in Joomla or not
	  if (typeof w.otuApp.appState==='undefined') {
	      APP.targetURL = 'control.php';
	      APP.targetURLLoadExercises = 'control.php';
	      APP.targetURLSaveWorkout = 'control.php';
	      APP.targetURLListWorkouts = 'control.php';
	      APP.targetURLDeleteWorkout = 'control.php';
	      APP.targetURLSetWorkout = 'control.php';
	  } else {
	      APP.targetURL = otuApp.appState.rootUrl +'index.php?option=com_otu_op&task=workoutgenerator.doesnotexist';
	      //APP.targetURLLoadExercises = otuApp.appState.rootUrl +'index.php?option=com_otu_op&task=workoutgenerator.loadExercises';
	      APP.targetURLSaveWorkout = otuApp.appState.rootUrl +'index.php?option=com_otu_op&task=workoutgenerator.saveWorkout';
	      APP.targetURLListWorkouts = otuApp.appState.rootUrl +'index.php?option=com_otu_op&task=workoutgenerator.listWorkouts';
	      APP.targetURLDeleteWorkout = otuApp.appState.rootUrl +'index.php?option=com_otu_op&task=workoutgenerator.deleteWorkout';
        APP.targetURLSetWorkout = otuApp.appState.rootUrl +'index.php?option=com_otu_op&task=workoutgenerator.setWorkout';
        APP.targetURLAskToEnterContest = otuApp.appState.rootUrl +'index.php?option=com_otu_op&task=workoutgenerator.askToEnterContest';
        APP.targetTrackExerciseData = otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=exerciseTracking.track';

    }
    
      APP.translations=(options.translations?options.translations:{});

      APP.options=options;
      // redirect the save button when disabled

      APP.$activeWorkout = $('#activeWorkout');

      if (!APP.options.videoOnly) {
        APP.Workout.title=$('#workout__title').text();
        document.querySelector('#workout__title').addEventListener('input', (e) => {
          APP.Workout.title=$('#workout__title').text();
        });

        if (APP.options.disableSaveButton) {
          APP.targetURLSaveWorkout = otuApp.appState.rootUrl +'index.php?option=com_otu_op&task=workoutgenerator.saveWorkoutDemo';
        }

        // disable the load button if 
        if (APP.options.disableLoadButton) {
          $('#openwo').addClass('disabled');

        }

        APP.$WOPanel = $('#workout');
        APP.$exerciseBank = $('#exerciseBank');
        APP.$savedBank = $('#savedBank');
      }
      //start methods within APP
      APP.API.init();
      APP.Video.init();
      APP.Bank.init();

      if (!APP.options.videoOnly) APP.Workout.init();
      if (!APP.options.videoOnly) APP.Contest.init();


      if (APP.options.autoPlay) APP.Video.player.play();
      if (APP.options.onEnded) APP.Video.player.on('ended', APP.options.onEnded);


      if (APP.options.workout && APP.options.videoOnly) {
        APP.Workout.setActiveWorkoutTimes();
        if (APP.options.workout.title) APP.Workout.title=APP.options.workout.title;
        if (APP.options.workout.trackType) APP.Workout.trackType=APP.options.workout.trackType;
      } else {
        // reset the trackType
        APP.Workout.trackType=1;
      }

      //console.log('TRACK TYPE ' +  APP.Workout.trackType);


      otuApp.onTemplatePositionDestroy(() => {
        if (typeof APP.Video.player !=='undefined') {
          console.log('Workout Generator - Pausing Video in OnTemplateDestroy');
          try {
          APP.Video.player.pause();
          } catch (err) {
            console.log('Workout Generator - Caught Error Pausing Video in OnTemplateDestroy');
          }
          console.log('Workout Generator - Done Pausing Video in OnTemplateDestroy');
        } else {
          console.log('Workout Generator - Cannot Pause Video in OnTemplateDestroy');
        }
			});
    },
    translate : function( tag, options={}) {
      console.log(APP.translations[tag]);
      if ( typeof APP.translations[tag]!== "undefined" ) return APP.translations[tag];
      return tag;
    },
    sortableDefaults: {
      cursor:       'move',
      connectWith:  '.dropzone',
      opacity:      0.75,
      revert:       150,
      placeholder:  'exercisePlaceholder',
      handle:       '.exercise__handle'
    },
    useSoundEffects: function() {
      return (otuApp.isCordovaApp() && !myApp.settings.muteSoundEffects)
    },
    Workout: {
      title:'No title set',
      trackType:1,
      activeWorkoutTimes:[],
      init: function(){
        const $activeW = APP.$activeWorkout;
        const $saveBtn = APP.Workout.$saveBtn = $('#savewo');
        // APP.Workout.Timer.reset();
        APP.Workout.Sortable.init();
        APP.Workout.Repeat.init();
        APP.Workout.Controls.listeners();
        APP.Workout.SavedWO.listeners();
      },
      reset: function() {
        $('#workout__title').empty();
        const $activeWO = $('#activeWorkout');
        $activeWO.children().remove();
        $activeWO.addClass('empty');
        $('#emptyActiveWorkoutMessage').show();

        APP.Workout.Repeat.setRepeats(1);
        APP.Workout.Timer.update();
      },
      Timer: {
        update: (repeats) => {
          repeats = ( typeof(repeats) !== 'undefined' ) ? repeats : APP.Workout.Repeat.getRepeats();

          // let repeats = APP.Workout.Repeat.getRepeats();
          var time = APP.Workout.Exercises.getTotalExerciseTime();
          var totalTimeSecs = time * repeats;
          APP.Workout.Timer.render(totalTimeSecs);
        },
        reset: function(){
          let time = 0;
          APP.Workout.Timer.render(time);
        },
        render: function(time){
          let timeHHMMSS = APP.Workout.Timer.secs2hhmmss(time);
          $('#workout__length').text(timeHHMMSS)
        },
        secs2hhmmss: function(seconds){
          var date = new Date(1970,0,1);
          date.setSeconds(seconds);
          return date.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, "$1");
        }
      },
      Repeat: {
        init: function(){
          const $repeat_slider = APP.Workout.Repeat.$slider = $('#workout__slider');
          let repeats = 1;
          APP.Workout.Repeat.renderSlider(repeats);
        },
        getRepeats: function(){
          return APP.Workout.Repeat.$slider.slider('value');
        },
        setRepeats: function(count){
          const $slider = APP.Workout.Repeat.$slider;
          const $repeatHandle = $('#repeat__handle');
          // move the slider
          $slider.slider('option', 'value', count);
          // update the handle displaying value
          $repeatHandle.text( count + 'x' );
        },
        renderSlider: function(repeats){
          let $slider = APP.Workout.Repeat.$slider;
          let $repeatHandle = $('#repeat__handle');
          $slider.slider({
            min:      1,
            max:      10,
            step:     1,
            value:    1,
            animate:  true,
            create: (eve, ui) => {
              var $thisSlider = $(eve.target);
              $repeatHandle.text( $thisSlider.slider('value') + 'x' );
              //As ui is an empty object when slider is created set value to 1
              // var repeats = APP.WORepeat.woRepeats($thisSlider);
              // update the total workout time
              // APP.WORepeat.updateTotalTime(repeats)
              APP.Workout.Timer.reset();
            },
            slide: function(eve, ui) {
              let repeats = ui.value;
              $repeatHandle.text( repeats + 'x' ); // update hande value
              // let totalExerciseTime = APP.Workout.Exercises.getTotalExerciseTime();
              // update the total workout time
              // APP.Workout.Timer.update(totalExerciseTime, repeats)
              if (APP.useSoundEffects()) createjs.Sound.play('workoutApp/button-1');

              APP.Workout.Timer.update(ui.value);
            },
            stop: (eve, ui) => {
              APP.Video.reset();
            }
          });
        }
      },
      Controls: {
        listeners: () => {
          // Workout Save Listener
          $('#savewo').on('click', function () {
            APP.Workout.Controls.save();
          });
          // Load List of Workouts
          $('#openwo').on('click', APP.Workout.Controls.list);
          // Clear Active Workout
          $('#clearwo').on('click', APP.Workout.Controls.clear);

          APP.$savedBank.on('hidden.bs.collapse', function() {
            // remove those Saved Workouts
            APP.$savedBank.children('li').remove();
          });
        },
        save: function(options={postOptions:{}}){
          if ( APP.Workout.$saveBtn.hasClass('disabled') ) {
            return false;
          }

          if (APP.useSoundEffects()) createjs.Sound.play('workoutApp/button-1');

          _('workout.js: Let\'s save this workout.');
          const $savedBank = $('#savedBank');
          //check how many workouts are already saved
          // let $savedWOs = $savedBank.children('.WOsaved');
          //if ($savedWOs.length === 0 || true ) {
          // Skipped the above check dont see why we need it, Joris
          if (true) {
          	//list all saved workouts
            // let $spinner = APP.Spinner.add('#savedBank', 'fa-2x', true, false ); – no need for spinner

            // let listRequest = APP.Workout.checkSavedWOs({
            //   debug: false
            // });

            // let title = $('#workout__title').text();
            let $exercises = APP.$activeWorkout.children('li.exercise');
            let exercisesArray = [];
            $.map($exercises, function(exercise, i) {
              const $exercise = $(exercise);
              const _id = $exercise.data('exerciseid');
              const _lengthIndex = $exercise.find('.exercise__slider').slider('value');
              exercisesArray.push({id: _id, lengthIndex: _lengthIndex});
            });

            let data2save = {
              title: $('#workout__title').text(),
              WOData: {
                exercises: exercisesArray,
                repeats: APP.Workout.Repeat.getRepeats()
              }
            };
            let APIdata = {
              action: 'saveWorkout',
              data: data2save,
              options:options.postOptions
            }

            // if we are on a cordovaApp and not logged in we save on the device
            if (otuApp.isCordovaApp() && otuApp.appUser.guest) {

              APP.$savedBank.collapse('hide');

              console.log('Workout Generator - Saving workout on device as ' + data2save.title);
              if (typeof myApp.settings.savedWorkouts === 'undefined') myApp.settings.savedWorkouts= {};
              myApp.settings.savedWorkouts[data2save.title]=data2save.WOData;
              myApp.writeSettings();

              // we still make the call to get the popup response
              APP.API.makeCallJoris(APP.targetURLSaveWorkout, APIdata, {
                debug:false,
                callback: (response) => { 
                  _("Save workout response callback: ", response);
                  if (typeof options.callback==='function') {
                    options.callback(response);
                  }
                }
              });

            } else {

              APP.$savedBank.collapse('hide');

              // Example of data structure sent to Ajax:
              // APIdata = {
              //   action: 'saveWorkout',
              //   data: {
              //     WOdata: {
              //       exercises: [
              //         0: {id: 4, lengthIndex: 0},
              //         1: {id: 5, lengthIndex: 3}
              //       ],
              //       repeats: 1
              //     },
              //     title: "Name of the workout"
              //   }
              // }
              APP.API.makeCallJoris(APP.targetURLSaveWorkout, APIdata, {
                debug:false,
                callback: (response) => { 
                  _("Save workout response callback: ", response);
                  if (typeof options.callback==='function') {
                    options.callback(response);
                  }
                }
              });
            }

          } else {
        	  console.log('Workout Generator - Custom Workout - Refused to save');
          }
          // trigger collapse
          // $savedBank.collapse();
          //if savedWO.length < 8 allow save else error
          //collect workout data
          //create object structure
          // Call API passing the prepared data
        },
        list: () => {
          /* if the list is displayed -> we're closing
           * thus don't run the API call and remove all the list items
           */

          if (APP.useSoundEffects()) createjs.Sound.play('workoutApp/button-1');

          let $savedBank = APP.$savedBank;
          if ( $savedBank.hasClass('in') ) {
            console.log('Collapsing saved workouts');
            // Collapse the list
            return;
          } else {
            if (otuApp.isCordovaApp() && otuApp.appUser.guest) {
              var workouts=myApp.settings.savedWorkouts;
              var _workouts=[];
              console.log('iterating workouts');

              for (var key in workouts) {
                  var _w={};
                  _w.title=key;
                  _w.WOData=workouts[key]
                  _w.id=key;
                  _workouts.push(_w);                
              }

              console.log(_workouts);
              console.log(workouts);


              APP.Workout.SavedWO.listWOs(_workouts);
              APP.Tooltip.init();

            } else {
              let response = APP.API.makeCallJoris(APP.targetURLListWorkouts, {'action': 'listWorkouts'}, {
              callback: (response) => {
                response = (typeof response === 'string') ? JSON.parse( response ) : response;
                _(`list: `, response);
                APP.Workout.SavedWO.listWOs( response );
                APP.Tooltip.init();
              }
              });
            }
          }
        },
        // checkSavedWOs: function() {
        //   // This should return a JSON string such as
        //   //
        //   // response = [
        //   //   {
        //   //     "id":1,
        //   //     "title":"Custom Workout 1",
        //   //     "WOData":{
        //   //       "exercises":[
        //   //         {"id":1,"lengthIndex":2},
        //   //         {"id":3,"lengthIndex":3}
        //   //       ],
        //   //       "repeats":2
        //   //     }
        //   //   },
        //   //   {
        //   //     "id":2,
        //   //     "title":"Easy Piesy",
        //   //     "WOData":{
        //   //       "exercises":[
        //   //         {"id":1,"lengthIndex":0},
        //   //         {"id":2,"lengthIndex":0}
        //   //       ],
        //   //       "repeats":4
        //   //     }
        //   //   },
        //   //   {
        //   //     "id":3,
        //   //     "title":"The Incredible Hulk",
        //   //     "WOData":{
        //   //       "exercises":[
        //   //         {"id":1,"lengthIndex":3},
        //   //         {"id":4,"lengthIndex":3},
        //   //         {"id":2,"lengthIndex":3},
        //   //         {"id":5,"lengthIndex":3},
        //   //         {"id":3,"lengthIndex":3},
        //   //         {"id":6,"lengthIndex":3}
        //   //       ],
        //   //       "repeats":10
        //   //     }
        //   //   },
        //   //   {
        //   //     "id":4,
        //   //     "title":"Saturday",
        //   //     "WOData":{
        //   //       "exercises":[
        //   //         {"id":6,"lengthIndex":2},
        //   //         {"id":3,"lengthIndex":1},
        //   //         {"id":1,"lengthIndex":3},
        //   //         {"id":5,"lengthIndex":0},
        //   //         {"id":2,"lengthIndex":1}
        //   //       ],
        //   //       "repeats":1
        //   //     }
        //   //   }
        //   // ]
        //   let savedWOs;
        //   return  APP.API.makeCallJoris(APP.targetURLListWorkouts, {'action': 'listWorkouts'}, {
        //     // callback: (response) => {
        //     //   _(`checkSavedWOs: `, response)
        //     //   return response;
        //     // }
        //   });
        // },
        clear: function(){
          if (APP.useSoundEffects()) createjs.Sound.play('workoutApp/button-1');


          APP.Workout.reset();
          APP.Bank.reset();
          APP.Workout.$saveBtn.addClass('disabled');
          APP.Workout.$contestBtn.addClass('disabled');

          APP.Video.reset();
          APP.$savedBank.collapse('hide');

        }
      },
      Exercises: {
        renderUI: function(exerciseItem) { // used when dropped into Custom Workout List
          var $li = $(exerciseItem); // make a shortcut for the current exercise
          var $clone=$li.clone();
          var exerciseData = { //prepare the data to pass to the render function
            name: $li.find('.exercise__name').text(),
            length: $li.data('length'),
            exerciseID: $li.data('exerciseid')
          };
          $li.find('.row').remove(); //get rid off the exercise gutts
          //render the UI template
          APP.Handlebars.render($li, $('#exerciseUITemplate'), exerciseData );
          APP.Workout.Exercises.Slider.render($li); // Display Slider
          $clone.appendTo('#exerciseBank');

        },
        removeItem: function($exercise) {
          //remove exercise UI
          APP.Bank.Exercises.removeExerciseUI($exercise);
          APP.Bank.Exercises.renderExercise($exercise);
          //$exercise.appendTo('#exerciseBank');
          $exercise.remove();

          var exercises = APP.$activeWorkout.children('li');
          if ( exercises.length < 1 ) { // if there's last item (+1 placeholder) being dragged out
            APP.$activeWorkout.addClass('empty');
            $('#emptyActiveWorkoutMessage').show();
            APP.Workout.$saveBtn.addClass('disabled');
            APP.Workout.$contestBtn.addClass('disabled');
          }


          //Recalculate Total Workout Time
          let time = APP.Workout.Exercises.getTotalExerciseTime();
          var repeats = APP.Workout.Repeat.getRepeats();
          APP.Workout.Timer.update();
          APP.Video.reset();
        },
        getTotalExerciseTime: function() {
          // let $workoutExercises = $('#activeWorkout').find('li');
          let $workoutExercises = APP.$activeWorkout.find('li');
          if ($workoutExercises.length < 1) {
            return 0;
          }
          var secsArray = $workoutExercises.map(function(){
            return parseInt($(this).find('.currentValue').text());
          });
          var totalSecs = 0;
          for (var i=0, ii=secsArray.length; i<ii; i++) {
            totalSecs += secsArray[i];
          }
          return totalSecs;
        },
        Slider: {
          render: function($exercise) {
            //read the array of video lengths
            let lengthArr = $exercise.data('length');
            //sort array from shortest to longest
            lengthArr = APP.Workout.Exercises.Slider.ascArraySort(lengthArr);
            let minLengthVal = lengthArr[0]; //save min value
            let maxLengthVal = lengthArr[lengthArr.length-1]; //save max value
            var $slider = $exercise.find('.exercise__slider'); //find the exercise slider element

            $slider.slider({
              min: 0,
              max: lengthArr.length-1,
              step: 1,
              value: 0,
              animate: true,
              create: function(eve, ui) {
                // Display the video length when slider is created
                APP.Workout.Exercises.Slider.displayValue($exercise);

                // let repeats = APP.Workout.Repeat.getRepeats();
                // let time = APP.Workout.Exercises.getTotalExerciseTime();
                // APP.Workout.Timer.update(time, repeats);
              },
              slide: function(eve,ui) {
                // Redraw (display again) the video length when user moves the slider
                if (APP.useSoundEffects()) createjs.Sound.play('workoutApp/button-1');

                APP.Workout.Exercises.Slider.displayValue($exercise, ui.value);

                APP.Workout.Timer.update();

              },
              stop: (eve, ui) => {
                APP.Video.reset();
              }
            });
          },
          getCurrentValue: function($exercise, lengthArrPosition) {
            // Check if the position of slider's handle has been supplied
            let lengthArrCurrentPosition = (typeof lengthArrPosition !== 'undefined') ? lengthArrPosition : $exercise.find('.exercise__slider').slider('value'); //If not,read its current value from the slider (create event)
            var lengthArr = $exercise.data('length'); //read the array of video lengths
            return lengthArr[lengthArrCurrentPosition];
          },
          setCurrentValue: function($exercise, lengthArrPosition) {
            const $slider = $exercise.find('.exercise__slider');
            $slider.slider('value', lengthArrPosition);
          },
          displayValue: function($exercise, lengthArrPosition) {
            //Get current Slider's value
            let currentValue = APP.Workout.Exercises.Slider.getCurrentValue($exercise, lengthArrPosition);
            //Prepare value HTML
            let html = '<span class="currentValue">'+ currentValue + '</span>&nbsp;s';
            //Display the value
            $exercise.find('.exercise__length')
              .html(html);
          },
          ascArraySort: function(array) {
            return array.sort(function(a, b) {
              return a-b;
            });
          }
        }
      },
      Sortable: {
        init: function(){
          
          APP.$activeWorkout.sortable(Object.assign({},APP.sortableDefaults,{connectWith:'#activeWorkout'}));
          APP.Workout.Sortable.modify();
        },
        modify: function(){
          const $activeWorkout = APP.$activeWorkout;
          $activeWorkout.sortable({
            receive: function(eve, ui) { //exercise's been dropped into Custom Workout
              // enable saving
              if ( APP.Workout.$saveBtn.hasClass('disabled')) { 
                APP.Workout.$saveBtn.removeClass('disabled'); APP.Workout.$contestBtn.removeClass('disabled');
              }
              // play a sound
              let exerciseId = $(ui.item).attr('data-exerciseid');
              if (APP.useSoundEffects()) createjs.Sound.play('workoutApp/drop-' + exerciseId);

              var $workoutList = $(eve.target); //select the Custom Workout element
              $workoutList.removeClass('empty'); //remove the drop in box border line
              $('#emptyActiveWorkoutMessage').hide();

              //render new guts
              APP.Workout.Exercises.renderUI(ui.item);

              let $exercise = $(ui.item);
              $exercise.on('click', '.exercise__trash', function(eve){
                APP.Workout.Exercises.removeItem($exercise)
              });


              APP.Workout.Timer.update();

              APP.Video.reset();
            },
            start: function(eve, ui) { //Exercise started to be dragged in Custom Workout
              var $target = $(eve.target);
              var exercises = $target.children('li');
              _(exercises.length);
              if ( exercises.length <= 2 && !$target.hasClass('empty') ) { // if there's last item (+1 placeholder) being dragged out
                $target.addClass('empty');
                $('#emptyActiveWorkoutMessage').hide();


              }
            },
            remove: function(eve, ui) {
              var $target = $(eve.target);
              var exercises = $target.children('li');
              // _(exercises.length);

              let $exercise = $(ui.item);

              if ( exercises.length < 1 ) { // if there's last item (+1 placeholder) being dragged out
                $target.addClass('empty');
                $('#emptyActiveWorkoutMessage').show();
                APP.Workout.$saveBtn.addClass('disabled');
                APP.Workout.$contestBtn.addClass('disabled');

              }


            },
            stop: (eve, ui) => {
              _('sorting');
          APP.Video.reset();            }
          });
        }
      },
      SavedWO: {
        listeners: function () {
          const $savedWObank = $('#savedBank');
          const $WOPanel = APP.$WOPanel;
          //Workout Load Listener
          $savedWObank.on('click', '> li:not(.no-saved-items)', APP.Workout.SavedWO.loadWorkout);
          //Workout Delete Listener
          $savedWObank.on('click', '.WOsaved__trash', APP.Workout.SavedWO.deleteWorkout);
          //Edit Workout Title
          $WOPanel.on('click', '.panel-heading', APP.Workout.SavedWO.editWOTitle);
        },
        loadWorkout: function() {
          _('Let\'s load the exercises :)');
          let $workout = $(this);
          let WOTitleText = $workout.data('title');
          let WOData = $workout.data('wo');
          const WOrepeats = WOData.repeats;
          const exercises = WOData.exercises;
          const $exerciseBank = APP.$exerciseBank;
          const $WOTitle = $('#workout__title');
          // enable save button
          if ( APP.Workout.$saveBtn.hasClass('disabled') ) {
            APP.Workout.$saveBtn.removeClass('disabled');
            APP.Workout.$contestBtn.removeClass('disabled');

          }
          //clear #activeWorkout and reset #exerciseBank
          APP.Workout.reset();
          APP.Bank.reset();
          // change Active Workout name
          $WOTitle.text(WOTitleText);
          // set repeat of workouts
          APP.Workout.Repeat.setRepeats(WOrepeats)
          // go through exercises array and process each exercise
          $.map(exercises, function(exercise, i) {
            //Select the right exercise from $exerciseBank
            const exerciseID = exercise.id;
            const exerciseLengthIndex = exercise.lengthIndex;
            // Find the jQuery element with corresponding 'data-exerciseid'
            const $exercise = $exerciseBank.find('[data-exerciseid="' + exerciseID + '"]');
            // render exercise in #activeWorkout & remove it from #exerciseBank
            $exercise.appendTo('#activeWorkout');
            APP.Workout.Exercises.renderUI($exercise);
            $exercise.on('click', '.exercise__trash', function(eve){
              APP.Workout.Exercises.removeItem($exercise)
            });

            // set exercise slider and display its value
            APP.Workout.Exercises.Slider.setCurrentValue($exercise, exerciseLengthIndex);
            APP.Workout.Exercises.Slider.displayValue($exercise, exerciseLengthIndex);
            // Remove the empty #activeWorkout styling
            $('#activeWorkout').removeClass('empty');
            $('#emptyActiveWorkoutMessage').hide();

          });
          // update total time of workout
          APP.Workout.Timer.update(WOrepeats);
          //Destroy all tooltips
          try {
              $('.WOsaved').tooltip('destroy');  
          } catch(err) {
        	  console.log('Workout Generator -  ERROR .WOSaved tooltip destroy failed');
          }
          //Hide bank of saved workouts
          APP.$savedBank.collapse('hide');
          APP.Video.reset();
        },
        deleteWorkout: (eve) => {
          eve.stopPropagation();
          let $trashCan = $(eve.target);
          let $workout = $trashCan.parents('li');
          let workoutID = $workout.attr('data-title');
          APP.Workout.SavedWO.confirmRender( $workout );
          let $confirmWrap = $workout.find('.confirmWrap');

          //Delete confirmed
          $workout.find('.btn-danger').click( function() {
            let data = {
              'action': 'deleteWorkout',
              'id': workoutID
            }
            APP.Spinner.add($confirmWrap, null, false, true);

            if (otuApp.appUser.guest && otuApp.isCordovaApp()) {
              delete myApp.settings.savedWorkouts[workoutID],
              myApp.writeSettings();
              $workout.remove();

              // hide if none left
              if ($('#savedBank li').length == 0) {
                APP.$savedBank.collapse('hide');
              }              

              
            } else {
              let deleteRequest = APP.API.makeCallJoris(APP.targetURLDeleteWorkout, data, {
                debug:false,
                callback: (response) => {
                  _(response);
                  $workout.remove();

                // hide if none left
                if ($('#savedBank li').length == 0) {
                  APP.$savedBank.collapse('hide');
                }   
                  // re-render and load

                }
              
              });
          }
            // let deleteRequest = APP.API.makeCall(data)
            //   .done(function(responseTxt) {
            //     _(responseTxt);
            //     $workout.remove();
            //   })
            //   .fail(function(responseTxt) {
            //     _(responseTxt);
            //     $confirmWrap.text('Server error');
            //   });

          });

          // Cancel delete
          $workout.find('.btn-default').click( function() {
            $confirmWrap.remove();
            $workout.find('.row').fadeIn();
          });
        },
        listWOs: function(workoutList) {
          // for each Workout
          if (workoutList && workoutList.length) {
            $.map(workoutList,function(singleEx, i){
              // render Workout
              APP.Workout.SavedWO.renderWO(singleEx);
    
            });
          } else {
            console.log('No saved workouts');
            $('#savedBank').html('<li class="list-group-item no-saved-items">You have no saved workouts.</li>');
          }
        },
        renderWO: function(data) {
          const $el = $('#savedBank');
          const $template = $('#savedWOtemplate');
          APP.Handlebars.render($el, $template, data);
        },
        confirmRender: function( $workout ) {
          // render confirmation box
          let confirmContainer = $('<div/>', {
            class: 'confirmWrap text-right',
            style: 'display: none;'
          });
          confirmContainer.text('Confirm deletion…');
          let confirmBtn = $('<button/>', {
            class: 'btn btn-danger btn-xs btn-confirm'
          }).html('<span class="glyphicon glyphicon-ok"></span>')
            .appendTo(confirmContainer);

          let cancelBtn = $('<button/>', {
            class: 'btn btn-default btn-xs btn-confirm'
          }).html('<span class="glyphicon glyphicon-remove"></span>')
            .appendTo(confirmContainer);

          $workout.find('.row').hide();
          $workout.append(confirmContainer);
          confirmContainer.click(function(eve) {
            eve.stopPropagation();
          });
          confirmContainer.fadeIn();
        },
        editWOTitle: function() {
          //let $title = $('#workout__title');
          //$title.attr({ contenteditable: true });
        }
      },
      getActiveWorkoutData: function($exercises) {
        let workoutData = {};
        $.map($exercises, function(exercise, ind){
          let $exercise = $(exercise);
          // get exercise ID
          let _id = $exercise.data('exerciseid');
          // get exercise Name
          let _name = $exercise.data('name');
          // get exercise lengthIndex
          let _lengthIndex = $exercise.find('.exercise__slider').slider('value');
          let _exerciseData = {
            id: _id,
            name: _name,
            lengthIndex: _lengthIndex
          };
          workoutData[ind] = _exerciseData;
        });
        return workoutData;
      },
      getActiveWorkoutTimes: function () { return APP.Workout.activeWorkoutTimes },
      setActiveWorkoutTimes: function($exercises = null) {
        let workoutData = [];

        if (!APP.options.videoOnly) {
          if ($exercises===null) $exercises = APP.$activeWorkout.children();

          let timeOffset=4; // offset for the intro
          var repeats = APP.Workout.Repeat.getRepeats();

          for (let i=0;i<repeats;i++) {
            $.map($exercises, function(exercise, ind){
              let $exercise = $(exercise);
              // get exercise ID
              let _id = $exercise.data('exerciseid');
              // get exercise Name
              let _name = $exercise.data('name');
              // get exercise lengthIndex
              let _lengthIndex = $exercise.find('.exercise__slider').slider('value');
              let _length=$exercise.data('length')[_lengthIndex];

              let _exerciseData = {
                id: _id,
                name: _name,
                lengthIndex: _lengthIndex,
                length:_length,
                start: timeOffset,
                end:timeOffset+_length,
              };
              timeOffset=_exerciseData.end;
              workoutData[ind+(i*$exercises.length)] = _exerciseData;

            });
          }
        } else {
          let timeOffset=4; // offset for the intro
          var repeats = APP.options.workout.WOData.repeats;
          for (let i=0;i<repeats;i++) {


            $.each( APP.options.workout.WOData.exercises, function(ind, exercise){
              let exerciseInfo = APP.exercises[exercise.id];

              let _exerciseData = {
                id: exerciseInfo.exerciseID,
                name: exerciseInfo.name,
                lengthIndex: exercise.lengthIndex,
                length:exerciseInfo.length[exercise.lengthIndex],
                start: timeOffset,
                end:timeOffset+exerciseInfo.length[exercise.lengthIndex],
              };
              timeOffset=_exerciseData.end;
              workoutData[ind+(i*APP.options.workout.WOData.exercises.length)] = _exerciseData;

            });
          }

        }
        APP.Workout.activeWorkoutTimes=workoutData;
        return workoutData;
      },
      getPlayingWorkout() {
        let currentTime = APP.Video.player.currentTime()
        let workoutTimes = APP.Workout.getActiveWorkoutTimes();

        let playingWorkout =  workoutTimes.find(element => {
            return (currentTime >= element.start && currentTime < element.end);
        });


        if (typeof playingWorkout==='undefined') {
          // console.log('Workout Generator - Not playing a workout');
        }

        return playingWorkout;

      }
    }, //end of Workout{}

    Bank: {
      init: function(){
        let $bank = APP.Bank.$exerciseBank = $('#exerciseBank');
        // Joris added the callback instead of the done below
        let exercises = APP.API.loadExercises();
        APP.exercises = exercises 
        if (!APP.options.videoOnly) {
          APP.Bank.Exercises.renderAll(APP.exercises);
          APP.Bank.Sortable.init();
        }
        
        // Test if we are in Joomla or not
        if (typeof w.otuApp.appState==='undefined') {
          exercises
          .done( (response) => {
            APP.exercises = JSON.parse(response);
            if (!APP.options.videoOnly) {
              APP.Bank.Exercises.renderAll(APP.exercises);
              APP.Bank.Sortable.init();
            }
          }).fail();
        }
      },
      reset: function() {
        $('#exerciseBank').children().remove();
        APP.Bank.Exercises.renderAll(APP.exercises);
        APP.Bank.Sortable.init();
      },
      Exercises: {
        renderAll: function(data){
          const $el = $('#exerciseBank');
          const $template = $('#exerciseBankTemplate');
          $el.empty();
          APP.Handlebars.render($el, $template, data);
        },
        removeExerciseUI: function($exercise){
          $exercise.find('.row').remove();
        },
        renderExercise: function($exercise){
          let $template = $('#exerciseBankGuts');
          let data = {
            name: $exercise.data('name')
          };
          APP.Handlebars.render($exercise, $template, data);
        }
      },
      Sortable: {
        init: function(){
          //Exercises in the Exercise Bank
          const $exerBank = APP.Bank.$exerciseBank;
          $exerBank.sortable(Object.assign({},APP.sortableDefaults));
          $exerBank.sortable({
            receive: function(eve, ui) {
              let $exercise = $(ui.item);
              APP.Bank.Exercises.removeExerciseUI($exercise);
              APP.Bank.Exercises.renderExercise($exercise);

              //Recalculate Total Workout Time
              let time = APP.Workout.Exercises.getTotalExerciseTime();
              var repeats = APP.Workout.Repeat.getRepeats();
              APP.Workout.Timer.update();
              APP.Video.reset();
            }
          });
        }
      }
    },

    Handlebars: {
      render: function($element, $template, data) {
        /*
         * Simple helper to stringify an object.
         * Usage: {{ JSON2string object }}
         */
        Handlebars.registerHelper('JSON2string', function(object){
          return JSON.stringify(object);
        });
        // Read template
        var template = $template.html();
        // Compile the template data into function
        var templateScript = Handlebars.compile(template);
        // render html
        var html = templateScript(data);
        // append to workout exercise list
        $element.append(html);
      }
    }, //end of Handlebars{}

    Video: {
      trackSaveInterval:15000,
      trackBuffer:{},
      lastTrackSave:null,
      lastUpdateCall:null,
      init: () => {
    	// check if we had already created a player  
    	if (typeof APP.Video.player === 'undefined') {   
    		APP.Video.createPlayer();
    	} else {
    		APP.Video.reset();
    	}

      },
      createPlayer: (callback) => {
        APP.Video.lastUpdateCall=null;
        APP.Video.trackBuffer={};
        APP.Video.lastTrackSave=null;


        let woPlayer = $('<video />', {
          id: 'workoutPlayer',
          class: 'embed-responsive-item video-js vjs-workout-skin'
        });
        woPlayer.appendTo('.workoutPlayerWrapper');
        APP.Video.getSources(function (sources) {
        	let playerOptions = {
                    html5: {
                      nativeAudioTracks: false,
                      nativeVideoTracks: false,
                      nativeTextTracks: false,
                      featuresNativeTextTracks: false,
                      debug: true,
                      preload:'auto',

                      vhs: {
                        overrideNative: true,
                        withCredentials: true,
                        
                      }
                    },
                    controls:true,
                    poster: 'images/workout-video-poster.jpg',
                    bigPlayButton: true,
                    sources: sources,
                    controlBar: { 
                      'pictureInPictureToggle': false
                    }
                  };

                  if (typeof w.otuApp.appState!=='undefined') {
                	  // We are in Joomla override the poster location
                	  playerOptions.poster=otuApp.appState.rootUrl +'templates/op/assets/images/customWorkout/workout-video-poster.jpg';
                  }

                  
                  
                  woPlayer = APP.Video.player = videojs('#workoutPlayer', playerOptions,function() {
                    videojs.log('Your player is ready!');
                    $(".workoutPlayerWrapper").fadeTo(200,1);

                    //var hls = this.tech({ IWillNotUseThisInPlugins: true }).hls;
                    //hls.on('blacklistplaylist', function(e,data) {console.log("videoJs blacklistplaylist",e,data)});
                    // woPlayer.tech_.on('blacklistplaylist', function(e,data) {console.log("videoJs blacklistplaylist",e,data)});
                  });   
                  /*
                  woPlayer.controlBar.progressControl.seekBar.off("mousedown");
                  woPlayer.controlBar.progressControl.seekBar.off("mouseup");
                  woPlayer.controlBar.progressControl.seekBar.off("touchstart");
                  woPlayer.controlBar.progressControl.seekBar.off("touchend");
                  woPlayer.controlBar.progressControl.seekBar.off("click");
                  */




                  APP.Video.setListeners(APP.Video.player);   			

                  
                  //let qualityLevels = APP.Video.player.qualityLevels();

                  //console.log(APP.Video.player.qualityLevels());


                  if (typeof callback == 'function') callback();
        	
        });
        
        // sets default video with instructions played
        // when no exercise is in current workout
        return woPlayer;
      },
      onTimeUpdate : () => {
          APP.Video.trackExerciseTime();

        },
      onPlay: () => {

        APP.Video.lastUpdateCall=new Date();

      }
      ,trackExerciseTime:(options={}) => {

        if (otuApp.appUser.guest) return;

        var now =new Date();

        if (APP.Video.lastUpdateCall===null) {
          console.log('Workout Generator: Resuming Exercise Tracking');
          APP.Video.lastUpdateCall=now;
          return true;
        }

        var timeSinceLastCall = now - APP.Video.lastUpdateCall;
        APP.Video.lastUpdateCall=now;

        let playingWorkout=APP.Workout.getPlayingWorkout();

        if (typeof playingWorkout !== 'undefined') {
          
          APP.Video.saveTrackedExerciseTime({
            workout:playingWorkout,
            time:timeSinceLastCall
          })

        } 

        if (options.pause) APP.Video.pauseTrackExerciseTime();


      },
      saveTrackedExerciseTime : (options = {}) => {

        if (otuApp.appUser.guest) return;

        let now =new Date();
        if (APP.Video.lastTrackSave==null) APP.Video.lastTrackSave=new Date();

        // console.log('Tracking ' + options.workout.id + ' adding ' + options.time);

        if (typeof APP.Video.trackBuffer[options.workout.id] === 'undefined') {
          APP.Video.trackBuffer[options.workout.id] = { id : options.workout.id, time: 0 };
          console.log('Workout Generator - Starting to track exercise ' + options.workout.name )
        }

        APP.Video.trackBuffer[options.workout.id].time=options.time + APP.Video.trackBuffer[options.workout.id].time;
        
        if ((now - APP.Video.lastTrackSave) > APP.Video.trackSaveInterval) {
          // we save to the server at the set interval
          APP.Video.saveTrackedExerciseTimeBuffer();

        }
      },
      saveTrackedExerciseTimeBuffer: (options={}) => {

        if (otuApp.appUser.guest) return;
        
        if (options.pause) APP.Video.pauseTrackExerciseTime();

        if (Object.keys(APP.Video.trackBuffer).length) {
          console.log('Workout Generator - Saving Exercise Tracking Buffer');

          let now = new Date();
          var _buffer = Object.assign({},APP.Video.trackBuffer);
          APP.Video.trackBuffer={};
          APP.Video.lastTrackSave=now;

          let data = {
            title: APP.Workout.title,
            trackedExercises : _buffer,
            type: APP.Workout.trackType
          }

          //console.log(data);
        
          APP.API.makeCallJoris(APP.targetTrackExerciseData, data, {
            debug:false,
            noSysInteraction:true,
            callback: (response) => { 
              console.log("Workout Generator - data tracked: ", response);

            }
          });
        }
      },
      pauseTrackExerciseTime: () => {
        console.log('Workout Generator: Pausing Exercise Tracking');
        APP.Video.lastUpdateCall=null;
      },
      ended : () => {
          var data = {
                  title : APP.Workout.title,
                  type : APP.Workout.trackType
              }
          
          if ( !otuApp.appUser.guest ) {
            otuApp.triggerAjaxPost(
                otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=exerciseTracking.exerciseFinished', 
                data, 
                {
                    responseType:'json',
                    debug:false,
                    noSysInteraction:true,
                    callback : (json) => {
                        console.log("Workout Generator - onEnded success: ", json);
                        // lets update the score and get the popup
                        if (json.markedHasExercised) {
                          var url=otuApp.appState.rootUrl + 'index.php?option=com_otu_op&task=appStateRefresh&popups=1';
                          otuApp.triggerAjaxGet(
                          url
                          );
                        }


                    }
                }
            );
          }
        }
      ,
      reset: (callback) => {
        // const _player = APP.Video.player;
        // resets the player into the init state with bigPlayButton
        // run on load of workout, clear of workout, play finished

      APP.Video.saveTrackedExerciseTimeBuffer();

    	console.log('Workout Generator - Reseting player');
      APP.Video.player.dispose();
      $(".workoutPlayerWrapper").fadeTo(100,0.6);

        APP.Video.createPlayer(callback);
        // _player.load(); // this was causing Media ERROR?!
      },
      setListeners: (player) => {
      	console.log('Workout Generator - Binding listeners');
        player.on('ended', () => {
          console.log('Workout Generator - Video ended');
          APP.Video.ended();
        	APP.Video.reset(player);
        });

        player.on("timeupdate", APP.Video.onTimeUpdate);
        player.on("play", () => {
          console.log('Workout Generator - Video Play');
          APP.Video.onPlay();
        });
        player.on("waiting", () => {
          console.log('Workout Generator - Video Waiting');
          APP.Video.saveTrackedExerciseTimeBuffer({pause:true})
        });
        player.on("pause", () => {
          console.log('Workout Generator - Video Pause');
          APP.Video.saveTrackedExerciseTimeBuffer({pause:true})
        });
        player.on("seeking", () => {
          console.log('Workout Generator - Video Seeking');
          APP.Video.pauseTrackExerciseTime();
        });


        //woPlayer.on("playing", () => console.log('PLAYING'));
        //woPlayer.on("seeked", () => console.log('SEEKED'));

      },
      getSources: (callback) => {
        const hasExercises = ($exercises) => ($exercises.length > 0) ? true : false;
        if (APP.options.videoOnly) {
          callback( {
            src: otuApp.appState.rootUrl + 'm3u8/active-workout.m3u8',
            type: 'application/x-mpegURL'
          });
        } else {
          let $exercises = APP.$activeWorkout.children();
          if (hasExercises($exercises)) {
            // Joris adding the callback
          APP.Video.setWorkoutSession($exercises, function() {
            // Check if in Joomla
                if (typeof w.otuApp.appState!=='undefined') {
                // There is no request returned in Joomla so we can just return the sources
                // But I wonder why this is not done one a callback pattern
                  console.log('Workout Generator - Setting workout to active workout');

                  callback({

                      src:  otuApp.appState.rootUrl + 'm3u8/active-workout.m3u8',
                      type:'application/x-mpegURL'
                    });
                } 
            });               
          } else {
            console.log('Workout Generator - Setting workout to default workout');
            callback( {
              src:  otuApp.appState.rootUrl + 'm3u8/default/default.m3u8',
              type: 'application/x-mpegURL'
              //type : "video/mp4"
            });
          }
        }
      },
      setWorkoutSession: ( $exercises, callback ) => {
        // Are there exercise in active workout
        // let $exercises = APP.$activeWorkout.children();
        // if (!$exercises.length) {
          // No: display error
          // _('No exercises in current workout.');
          // return false;
        // } else {
          // Yes: collect all the active workout
          let workoutData = APP.Workout.getActiveWorkoutData($exercises);
          // const workoutName = APP.$WOPanel.find('#workout__title').text()
          // Send collection to server and save it there as session
          let repeats = APP.Workout.Repeat.getRepeats();
          _('Workout Generator - Workout Data: ', workoutData);
          _('Workout Generator - Repeats: ', repeats);
          let APIdata = {
            action: 'setWorkout',
            platform: 'Joomla',
            data: { 'exercises': workoutData, 'repeats': repeats}
          }

          APP.Workout.setActiveWorkoutTimes();

          let request = APP.API.makeCallJoris(APP.targetURLSetWorkout, APIdata,
        		  {
        	  		debug:false,
        	  		callback:function(response) {
        	  			console.log('Workout Generator -  Active workout set');
        	  			callback();
        	  		}
        		  });
          return request;
        // }
      },
    }, //end of Video

    API: {
      ajaxOptions: {
        url:  'control.php',
        method: 'POST',
        // timeout: 1000
      },
      init: function() {
        $.ajaxSetup( APP.API.ajaxOptions );
      },
      makeCall: function(data) {
        let request = $.ajax({
          data: data
        });
        // On Ajax finished no matter what
        request.always(function(msg) {
          _('This message is shown always when Ajax call is finished');
        });
        // On Ajax failed
        request.fail(function(jqXHR, textStatus, errorThrown) {
          _('Ajax call failed: ');
          _(jqXHR);
          _('textStatus: ');
          _(textStatus);
          _('errorThrown: ');
          _(errorThrown);
        })
        return request;
      },
      makeCallJoris: (targetURL, data, Options) => {
      	Options.responseType='json';
        return otuApp.triggerAjaxPost(targetURL, data, Options);
      },
      loadExercises: function(options) {
        console.log('Workout Generator - Loading Exercises');
        return {
          "1": {
            "exerciseID": 1,
            "name": APP.translate("OP_WG_JOG_IN_PLACE"),
            "length": [46, 60, 90, 118],
            "playlists": ["jog-in-place-45-46s.m3u8", "jog-in-place-60-60s.m3u8", "jog-in-place-90-90s.m3u8", "jog-in-place-120-118s.m3u8"]
          },
          "2": {
            "exerciseID": 2,
            "name": APP.translate("OP_WG_UPRIGHTS"),
            "length": [45, 60, 80, 91],
            "playlists": ["uprights-40-45s.m3u8", "uprights-60-60s.m3u8", "uprights-80-80s.m3u8", "uprights-90-91s.m3u8"]
          },
          "3": {
            "exerciseID": 3,
            "name": APP.translate("OP_WG_SITUPS"),
            "length": [28, 33, 38, 47],
            "playlists": ["situps-25-28s.m3u8", "situps-30-33s.m3u8", "situps-35-38s.m3u8", "situps-45-47s.m3u8"]
          },
          "4": {
            "exerciseID": 4,
            "name": APP.translate("OP_WG_PUSHUPS"),
            "length": [26, 35, 40, 49],
            "playlists": ["pushups-20-26s.m3u8", "pushups-30-35s.m3u8", "pushups-35-40s.m3u8", "pushups-45-49s.m3u8"]
          },
          "5": {
            "exerciseID": 5,
            "name": APP.translate("OP_WG_JUMPING_JACKS"),
            "length": [45, 61, 76, 90],
            "playlists": ["jumping-jacks-40-45s.m3u8", "jumping-jacks-60-61s.m3u8", "jumping-jacks-80-76s.m3u8", "jumping-jacks-90-90s.m3u8"]
          },
          "6": {
            "exerciseID": 6,
            "name": APP.translate("OP_WG_CHICKEN_SQUATS"),
            "length": [37, 41, 45, 48],
            "playlists": ["chicken-squats-30-37s.m3u8", "chicken-squats-35-41s.m3u8", "chicken-squats-40-45s.m3u8", "chicken-squats-45-48s.m3u8"]
          }
        };
        /*

        let APIdata = {
          'action': 'loadExercises'
        };
        return APP.API.makeCallJoris(APP.targetURLLoadExercises, APIdata,options);
        */
      }
    }, //end of API
    Spinner: {
      add: function(container, size, block, prepend) {
        /* container (selector): where the spinner is going to be,
         *                       default: body
         * size (string): FA sizing class
         * block: if true spinner will be contained in block
         * prepend: if true spinner will be prepended into the container
         */
        container = (!!container) ? container : 'body';
        size = (!!size) ? size : '';
        block = (!!block) ? true : false;
        prepend = (!!prepend) ? true : false;
        // spinnerWrap is where the spinner will appear…
        // show spinner
        // let spinnerClass = 'fa fa-spinner fa-pulse fa-fw ' + size;
        let spinnerClass = 'glyphicon glyphicon-hourglass glyphicon-spin ' + size;
        // let $spinner = $('<i/>', { class: spinnerClass});
        let $spinner = $('<span/>', { class: spinnerClass});
        let $spinnerBlock = (!!block) ? $('<div/>', {class: 'spinnerBlock'}) : $('<span/>', {class: 'spinnerBlock'});

        if ( !!prepend ) {
          $spinnerBlock.append($spinner)
            .prependTo( container );
        } else {
          $spinnerBlock.append($spinner)
            .appendTo( container );
        }
        return $spinnerBlock;
      },
      remove: function($spinner) {
        $spinner.remove();
      }
    }, //end of Spinner

    Tooltip: {
      init: function() {
        // let merged = {...APP.Tooltip.options, ...{honza: 'Test'}};
        // _(merged);

        $(document).tooltip({
          selector: '.WOsaved',
          placement: 'right',
          container: '#workout',
          delay: {'show': 500, "hide": 30},
          html: true,
          title: APP.Tooltip.content
        });
      },
      content: function(){
        const $element = $(this);
        // const workout = $element.data('wo');
        const {exercises, repeats} = $element.data('wo');
        const title = $element.data('title');

        const $tooltipBody = $('<div/>',{
          class: 'tooltip__body'
        });
        // workout heading
        const $tooltipHeading = $('<h6/>',{
          class: 'tooltip__heading'
        }).text(title);
        $tooltipBody.append($tooltipHeading);
        // exercise list
        const $tooltipList = $('<ol/>',{
          class: 'tooltipList'
        });
        let exercisesData = APP.Tooltip.getExerciseData(exercises);
        let totalTime = 0;
        $.map(exercisesData, function(exe, i) {
          let $exercise = $('<li/>', {
            class: 'tooltip__exercise'
          }).text(exe.name + ': ' + exe.length + 's');
          $exercise.appendTo($tooltipList);
          totalTime += exe.length;
        });
        $tooltipBody.append($tooltipList);
        let totalTimeHMS = APP.Workout.Timer.secs2hhmmss(totalTime);
        let totalTimeRender = '<span class="glyphicon glyphicon-time"></span>&nbsp;' + totalTimeHMS+'s';
        // workout repeats
        const $tooltipRepeat = $('<div/>', {class: 'tooltip__repeats'}).html('<span class="glyphicon glyphicon-repeat"></span>&nbsp;' + repeats + 'x&nbsp;&nbsp;&nbsp;' + totalTimeRender).appendTo($tooltipBody);
        return $tooltipBody;
      },
      getExerciseData: function(exercisesArr) {
        let exercises = [];
        $.map(exercisesArr, function(exercise,i) {
          //Select the right exercise from $exerciseBank
          let exerciseID = exercise.id;
          let exerciseLengthIndex = exercise.lengthIndex;
          let $exercise = $('[data-exerciseid=' + exerciseID + ']');
          let lengthArr = $exercise.data('length');

          let exerciseData = {
            id: exerciseID,
            name: $exercise.data('name'),
            length: lengthArr[exerciseLengthIndex]
          };
          exercises.push(exerciseData);
        });
        return exercises;
      }
    },

    Tools: {
      checkJSON: function(strJSON) {
        try {
          JSON.parse(strJSON);
        } catch (e) {
          throw new Error('Server not returning JSON. ',e);
          // return false; Unreachable
        }
        return true;
      }
    }, //end Tools
    Contest: {
      init: function() {
        const $contestBtn = APP.Workout.$contestBtn = $('#contestWo');

        $('.workoutContestButton').click( function () {
          var contestId=$(this).attr('data-contest-id');
          console.log('Workout Generator - Workout contest entry button clicked ' + contestId);

          if ( APP.Workout.$saveBtn.hasClass('disabled') ) {
            return false;
          }
          _('Workout Generator - workout.js: Let\'s try to enter this workout to a contest.');
          const $savedBank = $('#savedBank');

            let $exercises = APP.$activeWorkout.children('li.exercise');
            let exercisesArray = [];
            $.map($exercises, function(exercise, i) {
              const $exercise = $(exercise);
              const _id = $exercise.data('exerciseid');
              const _lengthIndex = $exercise.find('.exercise__slider').slider('value');
              exercisesArray.push({id: _id, lengthIndex: _lengthIndex});
            });

            let data2save = {
              title: $('#workout__title').text(),
              WOData: {
                exercises: exercisesArray,
                repeats: APP.Workout.Repeat.getRepeats()
              },
              contest: {
                contestId:contestId
              }
            };

            let APIdata = {
              action: 'askToEnterContest',
              data: data2save,
            }

            APP.$savedBank.collapse('hide');

            APP.API.makeCallJoris(APP.targetURLAskToEnterContest, APIdata, {
            	debug:false,
              callback: (response) => { 
                _("Enter Contest Response Callback: ", response);

              }
            });

          }); 
      }
    }
  };

  // Test if we are in Joomla or not.
  if (typeof w.otuApp.appState==='undefined') {
	  $(document).ready(function()
		  {
        console.log('Workout Generator - No Joomla, Detected, document Ready event, ')
		    APP.init();
		  });
  } else {
	  //  Expose the workout generator so we can use it
	  window.workoutGenerator=APP;
  }

})(jQuery, window, undefined);

jQuery.fn.selectText = function(){
   var doc = document;
   var element = this[0];
   var range = null;
   if (doc.body.createTextRange) {
       range = document.body.createTextRange();
       range.moveToElementText(element);
       range.select();
   } else if (window.getSelection) {
       var selection = window.getSelection();
       range = document.createRange();
       range.selectNodeContents(element);
       selection.removeAllRanges();
       selection.addRange(range);
   }
};